import { createContext, useContext } from 'react';

export interface ResizablePanelsContextValue {
  panelWidths: number[];
  isDragging: boolean;
  dragHandleIndex: number;
  minWidths: number[];
  maxWidths?: number[];
  onResizeStart: (handleIndex: number, startX: number) => void;
}

export const ResizablePanelsContext = createContext<ResizablePanelsContextValue | undefined>(
  undefined
);

export function useResizablePanels() {
  const context = useContext(ResizablePanelsContext);
  if (!context) {
    throw new Error('useResizablePanels must be used within ResizablePanelsProvider');
  }
  return context;
}
